export default __webpack_public_path__ + "static/convoke-67c090d694d3ad9758e387fffb3c367a.jpg";